import { render, staticRenderFns } from "./send_notifications.vue?vue&type=template&id=4cae785c&scoped=true"
import script from "./send_notifications.vue?vue&type=script&lang=js"
export * from "./send_notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cae785c",
  null
  
)

export default component.exports